import { ScrollState } from 'src/modules/scroll/types/ScrollState';
import { RootState } from 'src/types/RootState';

export const getScrollState = (state: RootState): ScrollState => state.scroll;
